import { create } from 'zustand';

import { ExternalToken } from '../mainApi';
import * as ExternalKeysService from '../services/externalKeys.service';

type ExternalKeysState = {
  keys: ExternalToken[];
  isLoading: boolean;
  deletingKeyId: string | null;
  error: string | null;
};

type ExternalKeysActions = {
  loadKeys: () => Promise<void>;
  deleteKey: (keyId: string) => Promise<void>;
  resetTransientState: () => void;
};

export const useExternalKeysStore = create<ExternalKeysState & ExternalKeysActions>((set, get) => ({
  keys: [],
  isLoading: false,
  deletingKeyId: null,
  error: null,

  loadKeys: async () => {
    set({ isLoading: true, error: null });

    try {
      const keys = await ExternalKeysService.getExternalKeys();
      set({ keys, isLoading: false });
    } catch (error) {
      set({
        isLoading: false,
        error: error instanceof Error ? error.message : 'Error loading external keys',
      });
    }
  },

  deleteKey: async (keyId) => {
    set({ deletingKeyId: keyId, error: null });

    try {
      await ExternalKeysService.deleteExternalKey(keyId);
      set((state) => ({
        keys: state.keys.filter((key) => key.id !== keyId),
        deletingKeyId: null,
      }));
    } catch (error) {
      set({
        deletingKeyId: null,
        error: error instanceof Error ? error.message : 'Error deleting external key',
      });
    }
  },

  resetTransientState: () => {
    if (get().isLoading) {
      return;
    }

    set({ deletingKeyId: null, error: null });
  },
}));
